module.exports = __webpack_public_path__ + "static/img/puffindev.a987107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/puffindev.png
// module id = jvJD
// module chunks = 1